/**
 * Normalizes a raw backend MapBoundaries object into the frontend domain shape.
 *
 * Acts as an anti-corruption layer — converts backend PascalCase naming into the
 * frontend camelCase contract before the data reaches Redux or any plugin.
 *
 * @note Coordinate values are passed through as received from the backend.
 *   The backend is responsible for providing valid numeric latitude/longitude values.
 *   Downstream consumers (selectors and the mapBoundaries plugin) guard against null
 *   bounds before using them to fit the map.
 *
 * @param {Object} data - The raw API response object (communities or homes shape).
 * @returns {{ boundaryUrl: string|null, bounds: Object }|null}
 */
function extractMapBoundaries(data) {
  const rawBoundaries = data.communities?.MapBoundaries || data.homes?.MapBoundaries;

  if (!rawBoundaries ||
    !rawBoundaries.MinLatitude || !rawBoundaries.MinLongitude ||
    !rawBoundaries.MaxLatitude || !rawBoundaries.MaxLongitude
  ) {
    return null;
  }

  return {
    boundaryUrl: rawBoundaries.BoundaryUrl || null,
    bounds: {
      minLatitude: rawBoundaries.MinLatitude,
      minLongitude: rawBoundaries.MinLongitude,
      maxLatitude: rawBoundaries.MaxLatitude,
      maxLongitude: rawBoundaries.MaxLongitude,
    },
  };
}

export default extractMapBoundaries;